

import React from 'react';
import { Button, Container, Row, Col, Accordion, Card , Navbar, Nav, NavDropdown} from 'react-bootstrap';
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import qr3 from '../images/qr3.jpg'; 
import qr4 from '../images/qr4.png'; // Update with your image path
import './LandingPage.css';
import qrgenious from '../images/qrgenious.png'
import { useState } from 'react';

const LandingPage = () => {
  const [activeKey, setActiveKey] = useState(null); // Set default state to null (no item open initially)
  const [isNavOpen, setIsNavOpen] = useState(false); 
  const handleToggle = (key) => {
    // Toggle the active key: if the clicked key is the same, close it; if it's different, open it
    setActiveKey(activeKey === key ? null : key);
  };
  return (
    <div className="landing-page">
      {/* Navigation Bar */}
   <Navbar expand="md" className="navbar" variant="dark">
        <Container>
<Navbar.Brand href="#home" className="navbar-logo">
  <img 
    src={qrgenious} 
    alt="QRGenious Logo" 
    className="navbar-logo-image"
  />
  QRGenious
</Navbar.Brand>


          {/* Hamburger Icon for mobile */}
          <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={() => setIsNavOpen(!isNavOpen)} />
          
          {/* Navigation Links */}
          <Navbar.Collapse id="basic-navbar-nav" in={isNavOpen}>
            <Nav className="ms-auto"> {/* Using ms-auto to push nav items to the right */}
              <Nav.Item>
                <Link to="hero" smooth={true} duration={500} className="nav-link">
                  Home
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link to="how-it-works" smooth={true} duration={500} className="nav-link">
                  Features
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link to="pricing" smooth={true} duration={500} className="nav-link">
                  Pricing
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link to="faq" smooth={true} duration={500} className="nav-link">
                  FAQ
                </Link>
              </Nav.Item>
              <Nav.Item>
                <Link to="contact" smooth={true} duration={500} className="nav-link">
                  Contact
                </Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Hero Section */}
      <header className="hero-section" id="hero">
        <Container className="hero-container">
          <Row>
            <Col md={6} className="hero-content">
              <h1 className="hero-title">Create Smart QR Codes Instantly</h1>
              <p className="hero-subtitle">
                Customizable QR codes with analytics for your business, brand, or event.
              </p>
              <div className="cta-buttons">
               
<Button className="cta-btn primary-btn">
  <RouterLink to="/sign" style={{ color: 'white', textDecoration: 'none' }}>Get Started Free</RouterLink>
</Button>
                <Button className="cta-btn secondary-btn">Explore Features</Button>
              </div>
            </Col>
            <Col md={6}>
              <img src={qr3} alt="QRGenious Logo" className="hero-image" />
            </Col>
          </Row>
        </Container>
      </header>


{/* How It Works Section */}
<section className="how-it-works" id="how-it-works">
  <Container>
    <h2 className="section-title1">How It Works</h2>
    <Row className="text-center">
      <Col md={4}>
        <div className="step">
          <img 
            src={qr4}
            alt="Customize" 
            className="step-icon"
          />
          <h3 className="step-title">1. Customize</h3>
          <p>Pick your colors, styles, and add your logo.</p>
        </div>
      </Col>
      <Col md={4}>
        <div className="step">
          <img 
            src="https://img.icons8.com/ios/452/qr-code.png" 
            alt="Generate" 
            className="step-icon"
          />
          <h3 className="step-title">2. Generate</h3>
          <p>Instantly create your QR code with a click.</p>
        </div>
      </Col>
      <Col md={4}>
        <div className="step">
          <img 
            src="https://img.icons8.com/ios/452/graph.png" 
            alt="Track" 
            className="step-icon"
          />
          <h3 className="step-title">3. Track</h3>
          <p>Monitor usage and engagement with built-in analytics.</p>
        </div>
      </Col>
    </Row>
  </Container>
</section>


      {/* Features Section */}
{/* Features Section */}
<section className="use-cases" id="use-cases">
  <Container>
    <h2 className="section-title">Why Choose QRGenious</h2>
    <Row className="text-center">
      <Col md={4} style={{marginBottom:10}}>
        <div className="use-case-card">
          <i className="fas fa-store fa-3x use-case-icon"></i> {/* Font Awesome Small Business Icon */}
          <h4>Small Businesses</h4>
          <p>Connect customers to menus, payments, and more.</p>
        </div>
      </Col>
      <Col md={4} style={{marginBottom:10}}>
        <div className="use-case-card">
          <i className="fas fa-bullhorn fa-3x use-case-icon"></i> {/* Font Awesome Megaphone Icon */}
          <h4>Events & Marketing</h4>
          <p>Simplify sharing links or promotions.</p>
        </div>
      </Col>
      <Col md={4} style={{marginBottom:10}}>
        <div className="use-case-card">
          <i className="fas fa-graduation-cap fa-3x use-case-icon"></i> {/* Font Awesome Education Icon */}
          <h4>Education</h4>
          <p>Share resources with a scan.</p>
        </div>
      </Col>
    </Row>
  </Container>
</section>




      {/* Social Proof Section */}
      <section className="social-proof" id="social-proof">
        <Container>
          <blockquote className="testimonial">
            “With QRGenious, we boosted our event engagement by 40%!”
            <br />
            <em>- A Local Hyderabad Business Owner</em>
          </blockquote>
        </Container>
      </section>

      <section className="pricing-teaser" id="pricing">
        <Container>
          <h2 className="section-title1">Pricing</h2>
          <Row className="text-center">
<Col md={4}>
  <div className="pricing-card">
    <h3 className="pricing-title">Standard Plan</h3>
    <p className="pricing-price">₹1,500/year</p>
    <p className="pricing-description">
      Perfect for small businesses looking to create QR codes. <br />
      <strong>5% discount available for new users!</strong>
    </p>
    <Button className="cta-btn primary-btn">Get Started</Button>
  </div>
</Col>

<Col md={4}>
  <div className="pricing-card">
    <h3 className="pricing-title">Premium Plan</h3>
    <p className="pricing-price">₹3,000/year</p>
    <p className="pricing-description">
      All features + advanced analytics and custom branding. <br />
 
    </p>
    <Button className="cta-btn primary-btn">Get Started</Button>
  </div>
</Col>

            <Col md={4}>
              <div className="pricing-card">
                <h3 className="pricing-title">Enterprise Plan</h3>
                <p className="pricing-price">  Contact Us </p>
              <p className="pricing-description">
  Customized solutions designed for large enterprises with unique requirements.</p>

                <Button className="cta-btn primary-btn"><Link to="contact" smooth={true} duration={500} className="nav-link">Contact Us</Link></Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FAQ Section */}
    
      {/* FAQ Section */}
      <section className="faq-preview" id="faq">
        <Container>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <Accordion activeKey={activeKey}> {/* Pass activeKey to Accordion */}
            <Card style={{marginTop:8}}>
              <Accordion.Header onClick={() => handleToggle("0")}>
                What formats are supported?
              </Accordion.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  QR codes for URLs, text, files, business cards, and more.
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card style={{marginTop:8}}>
              <Accordion.Header onClick={() => handleToggle("1")}>
                Is my data secure?
              </Accordion.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body>
                  Yes, all QR codes are generated securely with encryption.
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card style={{marginTop:8}}>
              <Accordion.Header onClick={() => handleToggle("2")}>
                How do I track the QR code usage?
              </Accordion.Header>
              <Accordion.Collapse eventKey="2">
                <Card.Body>
                  We provide built-in analytics that shows scan details and more.
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card style={{marginTop:8}}>
              <Accordion.Header onClick={() => handleToggle("3")}>
                Can I customize my QR code design?
              </Accordion.Header>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  Yes, you can choose colors, logos, and more to make your QR code unique.
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Container>
      </section>

{/* Contact Us Section */}
 
    <section className="contact-us-section" id="contact">
      <Container>
        <h2 className="section-title">Contact Us</h2>
        <Row className="contact-us-section1">
          <Col xs={12} md={6} className="contact-details mb-4 mb-md-0">
            <h4 className="contact-subtitle">Our Office</h4>
            <p className="contact-address">
              Unit # 208, 2nd Floor, Ashoka Bhupal Chambers,<br />
              S.P.Road, Secunderabad - 500 003,<br />
              Telangana, INDIA
            </p>
            <p className="contact-info">
              <strong>Email:</strong>{" "}
              <a href="mailto:info@emedha.com" className="contact-link">
                info@emedha.com
              </a>
            </p>
            <p className="contact-info">
              <strong>Phone:</strong>{" "}
              <a href="tel:+919849164361" className="contact-link">
                +91 98491 64361
              </a>
            </p>
          </Col>

          <Col xs={12} md={6} className="map-container">
        
            <div className="map-wrapper">
              <iframe
                title="Google Map"
                allowFullScreen
                loading="lazy"
                src="https://www.google.com/maps/embed/v1/place?q=Unit+%23+208,+2nd+Floor,+Ashoka+Bhupal+Chambers,+S.P.Road,+Secunderabad+-+500+003,+Telangana,+INDIA&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
                style={{ border: 0 }}
              ></iframe>
            </div>
          </Col>
        </Row>
      </Container>
    </section>


      {/* Footer CTA Section */}
<footer className="final-cta" >
  <Container className="text-center">
    <h3 className="cta-footer-title">
      Ready to get started?
      <br />
      <span style={{ fontSize: '1.2rem', fontWeight: 'normal' }}>
        Start Generating QR Codes Today!
      </span>
    </h3>
    <Button className="cta-btn primary-btn">
      <RouterLink to="/login" style={{ color: 'white', textDecoration: 'none' }}>
        Create My QR Code
      </RouterLink>
    </Button>
  </Container>
</footer>


    </div>
  );
};

export default LandingPage;
